var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"task-reference-residential",attrs:{"promise":_vm.promise,"theme":"default"}},[(_vm.item)?_c('Residential',{attrs:{"value":_vm.item.reference,"theme":"list"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }